import {Injectable} from '@angular/core';
import {ISkeleton} from '../../interfaces/skeleton';
import {SkeletonEnum} from '../../enums/skeleton';
import {
  CardListSkeleton,
  ContainerSkeleton,
  DefaultSkeleton,
  MealPlanBuilderSkeleton,
  MealPlanUtilityPanelSkeleton,
  MultipleContainerSkeleton,
  RowSkeleton,
  RowsSkeleton,
  SmallCardListSkeleton,
  SphereSkeleton, StatisticsSkeleton,
  TwoContainerSkeleton,
  UtilityPanelProfileSkeleton,
  UtilityPanelStatisticsSkeleton
} from '../../config/skeleton';

@Injectable({
  providedIn: 'root'
})
export class SkeletonService {

  constructor() { }


  /**
   * build skeletons
   * @param skeleton return a skeleton
   */
  build(skeleton: SkeletonEnum): ISkeleton[] {
    switch (skeleton) {
      case SkeletonEnum.STATISTICS: {
        return StatisticsSkeleton;
      }
      case SkeletonEnum.MEAL_PLAN_BUILDER: {
        return MealPlanBuilderSkeleton;
      }
      case SkeletonEnum.DEFAULT: {
        return DefaultSkeleton;
      }
      case SkeletonEnum.MEAL_PLAN_UTILITY_PANEL: {
        return MealPlanUtilityPanelSkeleton;
      }
      case SkeletonEnum.CARD_LIST: {
        return CardListSkeleton;
      }
      case SkeletonEnum.SPHERE: {
        return SphereSkeleton;
      }
      case SkeletonEnum.ROWS: {
        return RowsSkeleton;
      }
      case SkeletonEnum.SMALL_CARD_LIST: {
        return SmallCardListSkeleton;
      }
      case SkeletonEnum.UTILITY_PANEL_STATISTICS: {
        return UtilityPanelStatisticsSkeleton;
      }

      case SkeletonEnum.CONTAINER: {
        return ContainerSkeleton;
      }
      case SkeletonEnum.TWO_CONTAINER: {
        return TwoContainerSkeleton;
      }
      case SkeletonEnum.MULTIPLE_CONTAINER: {
        return MultipleContainerSkeleton;
      }
      case SkeletonEnum.UTILITY_PANEL_PROFILE: {
        return UtilityPanelProfileSkeleton;
      }
      case SkeletonEnum.ROW: {
        return RowSkeleton;
      }
      default: {
        return DefaultSkeleton;
      }
    }
  }
}
